import * as Sentry from '@sentry/react';
import Cookies from 'js-cookie';

export enum CookieKeys {
  TENANT_COMPANY_ID = 'tenant_company_id',
}

const handleCookieError = <T>(fn: () => T): T | undefined => {
  if (navigator.cookieEnabled) {
    try {
      return fn();
    } catch (error) {
      Sentry.captureException(error);
      console.error(error);
    }
  }

  Sentry.captureException(new Error('Cookies are disabled'));
  console.error('Cookies are disabled');
};

const DEFAULT_COOKIE_OPTIONS: Cookies.CookieAttributes = {
  path: '/',
  expires: 365,
  sameSite: 'Lax',
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
};

export const cookieService = {
  get: (name: string): string | undefined => {
    return handleCookieError(() => Cookies.get(name));
  },
  set: (name: string, value: string, options?: Cookies.CookieAttributes): void => {
    handleCookieError(() => Cookies.set(name, value, { ...DEFAULT_COOKIE_OPTIONS, ...options }));
  },
  remove: (name: string, options?: Cookies.CookieAttributes): void => {
    handleCookieError(() => Cookies.remove(name, { ...DEFAULT_COOKIE_OPTIONS, ...options }));
  },
};
